var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Chevron(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.style, style = _c === void 0 ? {} : _c, onClick = _a.onClick;
    return (_jsxs("svg", __assign({ onClick: onClick, className: className, style: style, version: '1.1', id: 'Capa_1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', x: '0px', y: '0px', viewBox: '0 0 256 256', xmlSpace: 'preserve' }, { children: [_jsx("g", { children: _jsx("g", { children: _jsx("polygon", { points: '128,48.907 0,176.907 30.187,207.093 128,109.28 225.813,207.093 256,176.907 \t\t' }, void 0) }, void 0) }, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0)] }), void 0));
}
